import * as React from 'react';
export default function useCacheOptions(options) {
    const prevOptionMapRef = React.useRef(null);
    const optionMap = React.useMemo(() => {
        const map = new Map();
        options.forEach(item => {
            const { data: { value } } = item;
            map.set(value, item);
        });
        return map;
    }, [options]);
    prevOptionMapRef.current = optionMap;
    const getValueOption = (vals) => vals.map(value => prevOptionMapRef.current.get(value)).filter(Boolean);
    return getValueOption;
}
